module.exports = __webpack_public_path__ + "static/Wieczór panieński 1_Easy-Resize.com-08828f8d33dee632a555812ffda1d518.jpg";